// Leitura das linhas da conta que a tela consome: produtos, pagamentos e o
// aviso de "já foi impressa".
//
// Também estava repetido seis vezes em PointOfSale.components.tsx. Os mapas
// eram iguais palavra por palavra, tirando DUAS chaves que apareciam só em
// alguns lugares — e é por isso que existem as duas opções abaixo, em vez de um
// mapa só. A posição de cada chave no objeto foi preservada.

import {
  LinhaDeInfoDaConta,
  PagamentoDaConta,
  ProdutoDaConta,
} from "./conta.tipos";

export interface OpcoesDeLeituraDeProdutos {
  /** Vendedor que aparece na linha do produto. */
  seller: string | null | undefined;
  /**
   * `true` faz a chave `productExpanded` entrar no produto. A busca pelo campo
   * de texto a inclui; a busca pela tabela de pedidos NÃO — e lá a chave
   * simplesmente não existe no objeto.
   */
  comExpandido?: boolean;
  productExpanded?: boolean;
  /** Na mesa, cada produto carrega o lugar (`people`). No balcão, não existe. */
  comLugar?: boolean;
}

/** Converte as linhas de produto (orderInfo tipo 3) no que a tela desenha. */
export function lerProdutosDaConta(
  products: LinhaDeInfoDaConta[],
  { seller, comExpandido, productExpanded, comLugar }: OpcoesDeLeituraDeProdutos
): ProdutoDaConta[] {
  return (
    products.map((product: any, index: number, self: any[]) => {
      const productInfo = JSON.parse(product.orderInfoValue);
      const productObservations = productInfo.productObservations?.map(
        (observation: any) => {
          return {
            observationUuid: observation.observationUuid,
            observationName: observation.observationName,
            observationPrice: observation.observationPrice,
          };
        }
      );
      return {
        productOrderUuid: product.orderInfoUuid,
        productSelected: false,
        productSemiSelected: index === self.length - 1,
        ...(comExpandido ? { productExpanded: productExpanded ?? false } : {}),
        productUuid: productInfo.productUuid,
        productCode: productInfo.productCode,
        productPrinted: productInfo.productPrinted,
        productName: productInfo.productName,
        productPrice: Number(productInfo.productPrice)
          .toFixed(2)
          .replace(".", ","),
        seller: seller,
        productDiscount:
          Number(productInfo.productDiscount || 0)
            .toFixed(2)
            .replace(".", ",") ?? "0,00",
        productTotalPrice: (
          Number(productInfo.productPrice) +
          Number(productInfo.productDiscount || 0)
        )
          .toFixed(2)
          .replace(".", ","),
        ...(comLugar ? { people: productInfo.peopleNumber } : {}),
        productOrderedAt: product.createdAt,
        productObservations: productObservations,
        ...(productInfo.productComboInfo
          ? { productComboInfo: productInfo.productComboInfo }
          : {}),
      };
    }) ?? []
  );
}

/** Converte as linhas de pagamento (orderInfo tipo 10). */
export function lerPagamentosDaConta(
  orderInfo: LinhaDeInfoDaConta[]
): PagamentoDaConta[] {
  const payments = orderInfo.filter(
    (info: LinhaDeInfoDaConta) => info.orderInfoType === 10
  );
  return payments.map((payment: LinhaDeInfoDaConta) => {
    const paymentInfo = JSON.parse(payment.orderInfoValue);
    return {
      paymentMethodUuid: paymentInfo.paymentMethodUuid,
      paymentValue: paymentInfo.value,
    };
  });
}

/**
 * A conta já foi impressa? Fica no orderInfo tipo 14, e o valor pode chegar
 * como booleano ou como o texto "true".
 */
export function contaFoiImpressa(orderInfo: LinhaDeInfoDaConta[]): boolean {
  return orderInfo.some(
    (info: LinhaDeInfoDaConta) =>
      info.orderInfoType === 14 &&
      (info.orderInfoValue === "true" || info.orderInfoValue === true)
  );
}
